import React, { useState, useMemo } from 'react';
import { DataGrid, GridToolbar } from "@material-ui/data-grid";
import Spinner from '../../common/Spinner';
import { formatDate } from '../../../utils/basic';
import { Link } from "react-router-dom";

import useFetchAutoDGPlates from '../../Hooks/AutoDG/useFetchAutoDgPlates';


const AutoDGPlateList = () => {
    const [searchQuery, setSearchQuery] = useState("");
    //const [rows, setRows] = useState([]);

    const dgQuery = useFetchAutoDGPlates();
    const autoDgData = dgQuery?.isSuccess ? dgQuery?.data?.data : [];

    const filteredData = useMemo(() => {
        const formattedData = autoDgData?.map(item => ({
            "dg_serial_number": item?.autodg_serial_number,
            "plate_uuid": item?.plate_uuid,
            "run_uuid": item?.run_uuid,
            "upload_date": item?.upload_date ? formatDate(item.upload_date) : "",
            "report_ready": item?.report_ready,
            "id": crypto.randomUUID() // Generate a random ID for each row
        }));

        if (searchQuery.length >= 2) {
            return formattedData?.filter(item =>
                item?.dg_serial_number.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }
        return formattedData;
    }, [autoDgData, searchQuery]);

    const cols = [

        {
            field: 'plate_uuid',
            headerName: 'Plate UUID',
            description: 'Plate Uid',
            width: 450,
            renderCell: (params) => (
                params.row.report_ready ? (
                    <Link to={`dg_metrics/${params.row.plate_uuid}`} className="hover:cursor-pointer hover:text-blue-600 hover:underline">
                        {params.value}
                    </Link>
                ) : (
                    <span className="text-gray-400 cursor-not-allowed" title="Report is being generated...">
                        {params.value}
                    </span>
                )
            )
        },
        {
            field: 'dg_serial_number',
            headerName: 'DG Serial #',
            description: 'DG Serial #',
            width: 220
        },
        {
            field: 'run_uuid',
            headerName: 'Run UUID',
            description: 'Run UUID',
            width: 400,
        },
        {
            field: 'upload_date',
            headerName: 'Upload Date',
            description: 'Upload Date',
            width: 200
        },

    ];
    return (
        <>
            <div className="oneToolContainer flex flex-col gap-y-6">
                <h5 className="text-custom-green font-bold text-center">Auto DG Plates List</h5>

                <input
                    type="text"
                    value={searchQuery}
                    placeholder="Search DG Serial #..."
                    className="border border-gray rounded-[8px] px-2 py-1 text-sm w-40 focus:outline-none focus:ring-2 focus:ring-custom-green"
                    onChange={(event) => setSearchQuery(event.target.value)}
                />
                {dgQuery?.isFetching ? <Spinner text="Fetching Data... Pls wait" /> : dgQuery?.isSuccess ?

                    <div className="flex h-[75dvh]">
                        <DataGrid columns={cols} rows={filteredData} components={{
                            Toolbar: GridToolbar
                        }}
                        >
                        </DataGrid>
                    </div> : dgQuery?.isError ? <p>{dgQuery?.error}</p> : null}
            </div>
        </>
    );
};
export default AutoDGPlateList;